import React, {useEffect, useState} from 'react';
import {Card, Dropdown, Grid} from 'semantic-ui-react';
import {mapListToDropdownList} from '../../utils/mainUtils';
import '../styles.scss';
import SummaryModelTable from './summaryModelTable';
import {Actions} from '../../../common/actions';
import {connect} from 'react-redux';
import {destinyValues} from '../../../manageOrders/constants';
import {all} from '../../constants/all';

const InventoryByModel = (props) => {
  const [requestData, setRequestData] = useState({
    'master': '',
    'dealer': '',
    'destiny': '',
  });

  useEffect(() => {
    props.fetchDealers('dealers-vehicles');
    props.fetchModelsByFilters(requestData);
  }, []);

  const listDealers = mapListToDropdownList(props.listDealers, {
    'keys': ['identification'],
    'values': ['identification'],
    'texts': ['name'],
  }, true);

  const listModels = mapListToDropdownList(props.modelsSelector, {
    'keys': ['model'],
    'values': ['model'],
    'texts': ['description'],
  }, true);

  const handleShowOrders = (property, value) => {
    setRequestData({...requestData, [property]: value});
    props.fetchModelsByFilters({...requestData, [property]: value});
  };

  return (
    <Card fluid className="card-wrapper-auto">
      <div className="w-100 filters-inventory">
        <Grid className="w-100">
          <Grid.Row columns={3}>
            <Grid.Column>
              <Grid.Column width={3}>
                <h4>Modelo:</h4>
              </Grid.Column>
              <Grid.Column width={8}>
                <Dropdown
                  placeholder="TODOS"
                  fluid
                  search
                  selection
                  value={requestData.master}
                  onChange={(e, {value}) => handleShowOrders('master', value)}
                  options={listModels}
                  className='dropdown-main-inventory'
                />
              </Grid.Column>
            </Grid.Column>
            <Grid.Column>
              <Grid.Column width={7}>
                <h4>Dealer:</h4>
              </Grid.Column>
              <Grid.Column width={8}>
                <Dropdown
                  placeholder="TODOS"
                  fluid
                  search
                  selection
                  value={requestData.dealer}
                  onChange={(e, {value}) => handleShowOrders('dealer', value)}
                  options={listDealers}
                  className='dropdown-main-inventory'
                />
              </Grid.Column>
            </Grid.Column>
            <Grid.Column>
              <Grid.Column width={7}>
                <h4>Destino:</h4>
              </Grid.Column>
              <Grid.Column width={8}>
                <Dropdown
                  placeholder="TODOS"
                  fluid
                  search
                  selection
                  value={requestData.destiny}
                  onChange={(e, {value}) => handleShowOrders('destiny', value)}
                  options={all.concat(destinyValues)}
                  className='dropdown-main-inventory'
                />
              </Grid.Column>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
      <SummaryModelTable
        dataModels={props.modelsMenu || []}
        requestData={requestData}
      />
    </Card>
  );
};

const mapStateToProps = (state) => {
  return {
    'modelsMenu': state.vehiclesInventory.modelsMenu,
    'modelsSelector': state.vehiclesInventory.modelsSelector,
    'listDealers': state.dealer.list,
    'listOrigins': state.manageOrders.listOrigins,
  };
};

const {
  cleanHeaderValues,
  fetchDealers,
  fetchGetOrderSummary,
  fetchGetOriginsByFilters,
  fetchModelsByFilters,
  fetchOrigins,
} = Actions;

export default connect(mapStateToProps, {
  cleanHeaderValues,
  fetchDealers,
  fetchGetOrderSummary,
  fetchGetOriginsByFilters,
  fetchModelsByFilters,
  fetchOrigins,
})(InventoryByModel);
